exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-light[data-v-4543a406]:disabled{background-color:transparent!important}", ""]);

// exports
